var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuatation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.6789 9.38967C11.86 9.38967 11.1962 8.72582 11.1962 7.90692L11.1962 4C11.1962 1.79086 12.987 -6.13093e-07 15.1962 -4.19964e-07L16 -3.49691e-07C18.2091 -1.56562e-07 20 1.79086 20 4L20 7.92114C20 8.39559 19.9156 8.86626 19.7507 9.31114L16.3225 18.5617C16.0021 19.4262 15.1775 20 14.2556 20C12.7507 20 11.6882 18.5254 12.1646 17.0979L14.0854 11.3418C14.4059 10.3816 13.6912 9.38967 12.6789 9.38967ZM1.48275 9.38967C0.663848 9.38967 -2.82908e-06 8.72582 -2.75749e-06 7.90692L-2.41593e-06 4C-2.2228e-06 1.79086 1.79086 -1.59189e-06 4 -1.39876e-06L4.80383 -1.32849e-06C7.01297 -1.13536e-06 8.80383 1.79086 8.80383 4L8.80383 7.92114C8.80383 8.39559 8.71942 8.86626 8.55455 9.31114L5.12633 18.5617C4.80595 19.4262 3.98137 20 3.05939 20C1.55451 20 0.492064 18.5254 0.96842 17.0979L2.88925 11.3418C3.20968 10.3816 2.49502 9.38967 1.48275 9.38967Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuatation);
export default __webpack_public_path__ + "static/media/quatation.8bb4a64279d19d4b2baabd4c08512eec.svg";
export { ForwardRef as ReactComponent };